<template>
  <a-modal
    title="导入日志"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleVisible"
    width="880px"
  >
    <template>
      <a-form layout="inline" :form="form">
        <a-form-item label="操作人">
          <a-input
            placeholder="请输入操作人名称"
            v-decorator="['user']"
          ></a-input>
        </a-form-item>
        <a-form-item label="导入时间">
          <a-range-picker style="width: 300px" v-decorator="['date']" />
        </a-form-item>
        <span class="table-page-search-submitButtons">
          <a-button type="primary" @click="searchQuery" icon="search"
            >查询</a-button
          >
          <a-button
            type="primary"
            @click="searchReset"
            icon="reload"
            style="margin-left: 8px"
            >重置</a-button
          >
        </span>
      </a-form>

      <a-table
        style="margin-top: 15px"
        :columns="columns"
        rowKey="id"
        bordered
        :data-source="dataSource"
        :pagination="ipagination"
        @change="handleTableChange"
      >
        <template slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="onDownload(record.id)">下载文件</a>
        </template>
      </a-table>
    </template>
  </a-modal>
</template>
<script>
import { jsonAction } from '@/api/manage';
const columns = [
  {
    align: 'center',
    title: '导入时间',
    dataIndex: 'importTime',
    ellipsis: true,
    width: 200,
  },
  {
    align: 'center',
    title: '成功/失败/总数',
    dataIndex: 'num',
    ellipsis: true,
    width: 200,
  },
  {
    align: 'center',
    title: '操作人',
    dataIndex: 'user',
    ellipsis: true,
    width: 200,
  },

  {
    align: 'center',
    title: '操作',
    key: 'operation',
    width: 200,
    scopedSlots: {
      customRender: 'operation',
    },
  },
];
export default {
  data() {
    return {
      columns,
      visible: false,
      form: this.$form.createForm(this),
      dataSource: [
        {
          pageNo: 1,
          pageSize: 10,
          id: '1508362465989697537',
          title: '国泰君安君得利集合资产管理计划2017年第4季度管理人报告',
          category: '普通公告',
          noticeType: null,
          regularType: null,
          fundCode: 'V33333',
          content: '请详见附件内容！',
          successNumber: 1,
          failNumber: 0,
          publishTime: '2022-03-31',
          parentFundCode: null,
          channelCode: '产品公告',
          columnCode: null,
          isReview: null,
          moduleName: null,
          isHidden: null,
          status: null,
          startDate: null,
          endDate: null,
          publishType: null,
          isExpire: null,
          permissionType: null,
          riskLevel: null,
          fundCodes: null,
          proNatures: null,
          attachment:
            '国泰君安君得利集合资产管理计划2017年第4季度管理人报告.pdf',
          reason: null,
          importState: '导入成功',
        },
        {
          pageNo: 1,
          pageSize: 10,
          id: '1508362465989697538',
          title: '国泰君安君得利集合资产管理计划2017年第4季度托管人报告',
          category: '普通公告',
          noticeType: null,
          regularType: null,
          fundCode: 'V33333',
          content: '请详见附件内容！',
          successNumber: 2,
          failNumber: 0,
          publishTime: '2022-04-01',
          parentFundCode: null,
          channelCode: '产品公告',
          columnCode: null,
          isReview: null,
          moduleName: null,
          isHidden: null,
          status: null,
          startDate: null,
          endDate: null,
          publishType: null,
          isExpire: null,
          permissionType: null,
          riskLevel: null,
          fundCodes: null,
          proNatures: null,
          attachment:
            '国泰君安君得利集合资产管理计划2017年第4季度托管人报告.pdf',
          reason: null,
          importState: '导入成功',
        },
        {
          pageNo: 1,
          pageSize: 10,
          id: '1508362465989697539',
          title: '国泰君安君享新三板2号集合资产管理计划2017年第4季度托管人报告',
          category: '普通公告',
          noticeType: null,
          regularType: null,
          fundCode: '952080',
          content: '请详见附件内容！',
          successNumber: 3,
          failNumber: 0,
          publishTime: '2022-04-07',
          parentFundCode: null,
          channelCode: '关于我们',
          columnCode: null,
          isReview: null,
          moduleName: null,
          isHidden: null,
          status: null,
          startDate: null,
          endDate: null,
          publishType: null,
          isExpire: null,
          permissionType: null,
          riskLevel: null,
          fundCodes: null,
          proNatures: null,
          attachment:
            '国泰君安君享新三板2号集合资产管理计划2017年第4季度托管人报告.pdf',
          reason: null,
          importState: '导入成功',
        },
      ],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
    };
  },
  methods: {
    handleVisible() {
      this.visible = !this.visible;
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.ipagination = pagination;
      // this.loadData();
    },
    handleOk() {
      this.visible = !this.visible;
    },
    searchReset() {
      this.form.resetFields();
    },
    searchQuery() {},
  },
};
</script>
